/**
 * ポイント一覧API（/api/points）に要求する応答形式の解決
 *
 * jsonとcsvのどちらを要求するかだけを決める
 * csvの復元は pointsCsv.ts が持つ
 */

/**
 * ポイント一覧APIの応答形式
 *
 * バックエンドの points_csv.FORMAT_JSON / FORMAT_CSV と同じ値を持つ
 */
export const POINTS_API_FORMAT = {
  JSON: 'json',
  CSV: 'csv',
} as const

/**
 * POINTS_API_FORMAT が取る値
 */
export type PointsApiFormat = typeof POINTS_API_FORMAT[keyof typeof POINTS_API_FORMAT]

/**
 * 表示中のページに対応する一覧APIの応答の設定を返す
 *
 * ページの設定は MapConfig.extra_config のページごとのセクションにあり、一覧ページは points.points.response、マップページは map.points.response に置く
 * 一覧ページとマップページ以外は一覧APIを叩かないので、設定が降りていても読まない（店舗ページには map.points が降りている）
 */
function findResponseConfig(): PointsResponseConfig | undefined {
  switch (storelocator?.page) {
    case 'points':
      return storelocator?.points?.points?.response
    case 'map':
      return storelocator?.map?.points?.response
    default:
      return undefined
  }
}

/**
 * 画面が要求する応答形式を返す
 *
 * 無効値はjsonに倒す（画面を止めない）が、黙って倒すと軽量化が効いていないことに気づけないので警告を出す
 */
export function resolvePointsApiFormat(): PointsApiFormat {
  const format = findResponseConfig()?.format

  if (format === POINTS_API_FORMAT.CSV) {
    return POINTS_API_FORMAT.CSV
  }

  if (format !== undefined && format !== POINTS_API_FORMAT.JSON) {
    console.warn(`unsupported points api format on ${storelocator?.page} page, fallback to json: ${format}`)
  }

  return POINTS_API_FORMAT.JSON
}
